import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500 md:text-sm">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {item.href ? (
            <Link to={item.href} className="transition-colors duration-200 hover:text-primary-400">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-700">{item.label}</span>
          )}
          {index < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300" />}
        </span>
      ))}
    </nav>
  );
}